export default __webpack_public_path__ + "static/media/screenshot-02.85dda4aa.jpg";